import React from 'react';
import _merge from 'lodash/merge';
import { ListItemBasic, ListItemBasicProps } from 'components/List';
import { getContext } from 'common';
import Styled from './styles';

export interface BreadcrumbCompactsListItemBasicProps extends React.ComponentPropsWithRef<'li'> {
  /** To override the ListItemBasic. */
  listItemProps: Omit<ListItemBasicProps, 'children'>;
  /** The content of the item. */
  children: React.ReactNode;
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
}

/** Single BreadcrumbCompactsListItemBasic, represents a row within the `List`.
 *  Wraps <ListItemBasic />, use `listItemProps` to forward props to `ListItemBasic`.
 *  All other props than `listItemProps` will be provided to the root element  */
const BreadcrumbCompactsListItemBasic = React.forwardRef<HTMLElement, BreadcrumbCompactsListItemBasicProps>((props: BreadcrumbCompactsListItemBasicProps, ref) => getContext(({ RTL, theme }) => {
  const {
    children,
    listItemProps,
    theme: themeProp,
    ...otherProps
  } = props;
  const resolvedTheme: any = _merge({}, theme.BREADCRUMBS, themeProp);
  return (
    <Styled.BreadcrumbCompactsListItem $rtl={RTL} as="li" $theme={resolvedTheme} {...otherProps}>
      <ListItemBasic ref={ref} as="div" {...listItemProps}>
        {children}
      </ListItemBasic>
    </Styled.BreadcrumbCompactsListItem>
  );
}));

BreadcrumbCompactsListItemBasic.displayName = 'BreadcrumbCompactsListItemBasic';

BreadcrumbCompactsListItemBasic.defaultProps = {
  theme: {},
};

export default BreadcrumbCompactsListItemBasic;